import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';

export default class Announcements extends Component {
  render() {
    return (
      <span />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/announcements.js